module.exports = __webpack_public_path__ + "img/XP.9f60098a.png";